// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface InformationBannerProps {
    bgColor: 'green' | 'beige'
    image: {
        srcSmall: string
        srcMedium: string
        srcLarge: string
        src: string
        alt?: string
    }
    title?: string
    intro?: string
    content?: string
}

export default function InformationBanner({
    bgColor,
    image,
    title,
    intro,
    content
}: InformationBannerProps) {
    return (
        <Section
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark'
            )}
            textColor='text-dark'
            className='information-banner'
        >
            {image && <Image
                srcSmall={[`${image.srcSmall}`, 574]} // 550x750
                srcMedium={[`${image.srcMedium}`, 991]} // 1000x1100 
                srcLarge={[`${image.srcLarge}`, 1439]} // 1400x900
                src={image.src} // 1900x1100
                alt={image.alt || 'Background Image'}
                className='information-banner__bg cover'
            />}

            <div className='grid-container'>
                <div
                    className='information-banner__block'
                    style={{ backgroundColor: bgColor === 'green' ? '#D2DFD2' : '#EDE1D4' }}
                >

                    <div
                        className='mobile-bg'
                        style={{ backgroundColor: bgColor === 'green' ? '#D2DFD2' : '#EDE1D4' }}
                    ></div>

                    <div className='block-wrapper'>

                        <div className='block-wrapper__left'>

                            {isNonWhitespaceString(title) && (
                                <h2 className='title-md title'>
                                    {title}
                                </h2>
                            )}

                            {isNonWhitespaceString(intro) && (
                                <div
                                    className='text-md intro'
                                    dangerouslySetInnerHTML={{ __html: intro }}
                                    suppressHydrationWarning
                                />
                            )}

                        </div>

                        <div className='block-wrapper__right'>
                            <RichText content={content} />
                        </div>

                    </div>
                </div>
            </div>
        </Section>
    )
}

